const getNameAndValueFromSlider = (el) => {
	const chart = el.querySelector(
		'.facet-user-range-chart[data-range-chart-min-val][data-range-chart-max-val]'
	);
	const sliderInput = el.querySelector(
		'.facet-user-range-submit-values[name][value]'
	);
	let defaultValue = '';
	let maxVal = '0';
	let minVal = 'any';
	let name = '';
	let value = '';

	if (chart) {
		minVal = chart.getAttribute('data-range-chart-min-val') || minVal;
		maxVal = chart.getAttribute('data-range-chart-max-val') || maxVal;
		defaultValue = `${minVal}-${maxVal}`;
		value = defaultValue;
	}

	if (sliderInput) {
		name = sliderInput.getAttribute('name');
		const selectedValuesArr = sliderInput.getAttribute('value').split('-');
		value = `${selectedValuesArr[0] || minVal}-${
			selectedValuesArr[1] || maxVal
		}`;
	}

	return {
		name,
		value,
		defaultValue
	};
};

export default getNameAndValueFromSlider;
